import { api } from './client';

export const fetchOpenPositions = () =>
    api.get<Response.getOpenPosition>('/futures/open-positions');

export const fetchSymbols = () =>
    api.get<Response.Symbols>('/futures/symbols');

export type ClosedPositionPeriod = '7d' | '30d' | '90d' | '180d';

export interface ClosedPosition {
    symbol:   string;
    pnl:      number;
    asset:    string;
    time:     number;
    trade_id: string;
}

export interface ClosedPositionsSummary {
    total:     number;
    wins:      number;
    losses:    number;
    total_pnl: number;
    winrate:   number;
}

export interface ClosedPositionsResponse {
    success:   boolean;
    period:    string;
    positions: ClosedPosition[];
    summary:   ClosedPositionsSummary;
}

export function fetchClosedPositions(period: ClosedPositionPeriod, symbol?: string): Promise<ClosedPositionsResponse> {
    const params = new URLSearchParams({ period });
    if (symbol) params.set('symbol', symbol);
    return api.get<ClosedPositionsResponse>(`/futures/closed-positions?${params}`);
}

export interface SlTpOrder {
    symbol:       string;
    type:         'STOP_MARKET' | 'TAKE_PROFIT_MARKET' | 'STOP' | 'TAKE_PROFIT';
    side:         'BUY' | 'SELL';
    positionSide: 'LONG' | 'SHORT' | 'BOTH';
    stopPrice:    string;
    origQty:      string;
}

export const fetchSlTpOrders = () =>
    api.get<SlTpOrder[]>('/futures/sl-tp-orders');
